import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import useWindowSize from '../../hooks/useWindowSize';
import getScrollbarSize from '../../utils/getScrollbarSize';

const Popover = ({
  open, close, children, align, widthClass, marginClass,
}) => {
  const node = useRef();
  const windowSize = useWindowSize();

  // TODO: either replace with material UI clickaway listener,
  // or if that doesn't work for us for some reason,
  // move this to a hook and reuse for modal
  useEffect(() => {
    const { width } = getScrollbarSize();

    const handleClick = (e) => {
      if ((open && node.current && node.current.contains(e.target))
      || windowSize.width - e.pageX <= width) {
        // inside click
        return;
      }
      // outside click
      close();
    };

    // add when mounted
    if (typeof window !== 'undefined' && open) {
      document.addEventListener('mousedown', handleClick);
    }

    // return function to be called when unmounted
    return () => {
      if (typeof window !== 'undefined') {
        document.removeEventListener('mousedown', handleClick);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (open
    && (
      <div
        ref={node}
        className={clsx('absolute bg-white origin-top-right rounded-md shadow-2xl z-20 border',
          widthClass || 'w-full', align || 'md:right-0', marginClass || 'mt-2')}
      >
        {children}
      </div>
    )
  );
};

Popover.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  align: PropTypes.string,
  widthClass: PropTypes.string,
  marginClass: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.object,
  ]),
};

Popover.defaultProps = {
  children: undefined,
  align: undefined,
  widthClass: undefined,
  marginClass: undefined,
};

export default Popover;
